export function getGrecaptcha() {
  let grecaptcha = window['grecaptcha'];
  if (typeof grecaptcha === 'undefined') {
    grecaptcha = {
      /**
       * @param {() => void} cb
       */
      ready(cb) {
        if (typeof window['grecaptcha'] === 'undefined') {
          // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
          // configuration. By default, any functions listed in its 'fns' property
          // are automatically executed when reCAPTCHA loads.
          const c = '___grecaptcha_cfg';
          window[c] = window[c] || {};
          (window[c]['fns'] = window[c]['fns'] || []).push(cb);
        } else {
          cb();
        }
      }
    };
  }

  return grecaptcha;
}
